import { render, staticRenderFns } from "./IconEmail.vue?vue&type=template&id=268b92d2&"
import script from "./IconEmail.vue?vue&type=script&lang=js&"
export * from "./IconEmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports